const personalDashboardKpiColorsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_PERSONAL_DASHBOARD_KPI_COLORS':
            return action.payload || {}
        default:
            return state
    }
}

export default personalDashboardKpiColorsReducer
